// URL Filters
const extractHashQueries = (hash_query: string) => {
    // Split query to seperate parameters with delimiter &
    // ex: brand=abb+fanuc

    let queries = [];
    if(hash_query.split("filter?")[1] != undefined)
        queries = hash_query.split("filter?")[1].split("&");
    let search_params = {};

    queries.map((q) => {
        // Split queries by = to retrieve name and value
        let q_set = q.split("=");

        if(q_set[1] == undefined)
            q_set[1] = ""

        if(q_set[0] != "")
            search_params[q_set[0]] = q_set[1];
    });

    return search_params;
};

const extractRobotParamSets = (key, value) => {
    let valid_param_keys = [
        "name",
        "brand",
        "type",
        "axes",
        "reach",
        "payload",
        "weight",
        "repeatability",
        "model",
        "application",
    ];
    let extracted_param_sets = {};
    let param_key = key.toLowerCase();

    if (valid_param_keys.includes(param_key)) {
        extracted_param_sets[param_key] = convertRobotParameter(key, value);
    }

    return extracted_param_sets;
};
const convertRobotParameter = (key, value) => {
    switch(key) {
        case "name":
            return value.trim().toLowerCase();

        case "brand":
        case "type":
        case "application":
            return (
                value.trim().toLowerCase().split(" ")
                .map(entry => {
                    if(entry == "ext.axis")
                        return "ext. axis"
                    else
                        return entry.replaceAll("-", " ");
                })
            );
        
        case "axes":
            return value.trim().toLowerCase().split(" ");

        case "reach":
        case "payload":
        case "weight":
        case "repeatability":
            return value.trim().split("-");
    }
};

const extractStationParamSets = (key, value) => {
    let valid_param_keys = [
        "name",
        "application",
        "feature",
        "brand",
        "mechanism_type",
        "mechanism_count",
        "tool_count",
        "object_count",
        "size",
    ];
    let extracted_param_sets = {};
    let param_key = key.toLowerCase();

    if (valid_param_keys.includes(param_key)) {
        extracted_param_sets[param_key] = convertStationParameter(key, value);
    }

    return extracted_param_sets;
};
const convertStationParameter = (key, value) => {
    switch(key) {
        case "name":
            return value.trim().toLowerCase();

        case "size":
            return value.trim().toLowerCase().split(" ");

        case "application":
        case "feature":
        case "brand":
        case "mechanism_type":
            return (
                value.trim().toLowerCase().split(" ")
                .map(entry => {
                    if(entry == "ext.axis")
                        return "ext. axis"
                    else
                        return entry.replaceAll("-", " ");
                })
            );

        case "mechanism_count":
        case "tool_count":
        case "object_count":
            return value.trim().split("-");
    }
};

const extractAddinParamSets = (key, value) => {
    let valid_param_keys = [
        "name",
        "publisher",
        "category",
        "price",
    ];
    let extracted_param_sets = {};
    let param_key = key.toLowerCase();

    if(valid_param_keys.includes(param_key)) {
        extracted_param_sets[param_key] = convertAddinParameter(key, value);
    }

    return extracted_param_sets;
};

const convertAddinParameter = (key, value) => {
    switch(key) {
        case "name":
        case "price":
            return value.trim().toLowerCase();

        case "publisher":
        case "category":
            return (
                value.trim().toLowerCase().split(" ").map(
                    (entry) => { 
                        if(entry == "plug-in")
                            return entry;
                        else
                            return entry.replaceAll("-", " ");
                    }
                )
            );
    }
};

const extractPostParamSets = (key, value) => {
    let valid_param_keys = [
        "name",
        "brand",
        "controller",
        "extension",
    ];
    let extracted_param_sets = {};
    let param_key = key.toLowerCase();

    if(valid_param_keys.includes(param_key)) {
        extracted_param_sets[param_key] = convertPostParameter(key, value);
    }

    return extracted_param_sets;
};

const convertPostParameter = (key, value) => {
    switch(key) {
        case "name":
            return value.trim().toLowerCase();

        case "brand":
        case "controller":
        case "extension":
            return (
                value.trim().toLowerCase().split(" ").map(
                    (entry) => { 
                        if(entry == "plug-in")
                            return entry;
                        else
                            return entry.replace(/%20/g, " ").replace(/-/g, " ");
                    }
                )
            );
    }
};


// Retrieve url filters and extract params
let extracted_params = {};
const extractUrlQueryOnMessage = (library:string, hash: string) => {
    if (!window.Settings.LOCAL_BUILD) {
        //console.log(event.data);
        //console.log(JSON.stringify(event, null, 4));
        window.location.hash = hash;
    }

    if (window.location.hash != "") {
        let hash_params = extractHashQueries(window.location.hash);

        for (const key in hash_params) {
            let temp_params = {};

            if(library == "robot") {
                temp_params = extractRobotParamSets(
                    key, 
                    hash_params[key].split("+").join(" ")
                );
            };

            if(library == "station") {
                temp_params = extractStationParamSets(
                    key,
                    hash_params[key].split("+").join(" ")
                );
            };

            if(library == "addin") {
                temp_params = extractAddinParamSets(
                    key,
                    hash_params[key].split("+").join(" ")
                );
            };

            if(library == "post") {
                temp_params = extractPostParamSets(
                    key,
                    hash_params[key].split("+").join(" ")
                )
            };

            if (Object.keys(temp_params).length > 0)
                extracted_params = Object.assign(extracted_params, temp_params);
        }
    }

    return extracted_params;
};

export {
    extracted_params,
    extractUrlQueryOnMessage,
}